import Cookies from 'js-cookie';

const env = import.meta.env.VITE_ENVIRONMENT || import.meta.env.NODE_ENV;
let teacherUrl =
  import.meta.env.VITE_TEACHER_URL || 'https://teacher-qa.eedi.com';
let apiUrl = '';
let functionsApiUrl = '';
let omrFunctionsApiUrl = '';
let stripeApiKey = '';
let flowApiUrl = '';
let keystrokeLoggerUrl = '';
let experimentsClientKey = '';
switch (env) {
  case 'prod':
    apiUrl = 'https://api.eedi.com';
    functionsApiUrl = 'https://eedi-functions-api-prod.azurewebsites.net';
    omrFunctionsApiUrl = 'https://omr-api.eedi.com';
    stripeApiKey = 'pk_live_pypeIsnPgZnGRFxT0peYl4X5';
    flowApiUrl = 'https://flow-api.eedi.com';
    teacherUrl = 'https://teacher.eedi.com';
    keystrokeLoggerUrl = 'https://keystrokeapi-prod.azurewebsites.net';
    experimentsClientKey = 'sdk-ANiiCngQrPG9E0VD';
    break;
  default:
    apiUrl = import.meta.env.VITE_API_URL || 'https://api-qa.eedi.com';
    functionsApiUrl =
      import.meta.env.VITE_FUNCTIONS_API_URL ||
      'https://eedi-functions-api-qa.azurewebsites.net';
    omrFunctionsApiUrl =
      import.meta.env.VITE_OMR_FUNCTIONS_API_URL ||
      'https://omr-api-qa.eedi.com';
    stripeApiKey =
      import.meta.env.VITE_STRIPE_API_KEY || 'pk_test_yFbC08JVbfxTN3XcErgUkY9i';
    flowApiUrl =
      import.meta.env.VITE_FLOW_API_URL || 'https://flow-api-qa.eedi.com';
    keystrokeLoggerUrl =
      import.meta.env.VITE_KEYSTROKE_LOGGER_URL ||
      'https://keystrokeapi-qa.azurewebsites.net';
    experimentsClientKey =
      import.meta.env.VITE_EXPERIMENTS_CLIENT_KEY || 'sdk-Y8Hb6E2G907LFbn';
    break;
}

// Export these settings and allow them to be overridden by local .env files
export const API_URL = apiUrl;
export const FUNCTIONS_API_URL = functionsApiUrl;
export const OMR_FUNCTIONS_API_URL = omrFunctionsApiUrl;
export const FLOW_API_URL = flowApiUrl;
export const ENVIRONMENT = env;
export const PRODUCTION = env === 'prod';
export const TEACHER_URL = teacherUrl;
export const FAMILY_URL = window.location.origin;
export const DEV_MODE = import.meta.env.VITE_DEV;

export const KEYSTROKE_LOGGER_URL = keystrokeLoggerUrl;

export const EXPERIMENTS_API_URL =
  import.meta.env.VITE_EXPERIMENTS_API_URL ||
  'https://experiments-qa.eedi.com:3100'; // Same URL for both prod and qa, just a different client key.
export const EXPERIMENTS_CLIENT_KEY = experimentsClientKey;
export const EXPERIMENTS_DEV_MODE = env !== 'prod';

// The BUILD_ID is the Azure Dev ops build identifier.
export const BUILD_ID = import.meta.env.VITE_BUILD_ID || 'Development';
export const DISABLE_ANALYTICS =
  import.meta.env.VITE_DISABLE_ANALYTICS || false;
export const STRIPE_API_KEY =
  import.meta.env.VITE_STRIPE_API_KEY || stripeApiKey;
export const IMAGE_URL =
  import.meta.env.VITE_IMAGE_URL || 'https://images.diagnosticquestions.com';
export const MARKETING_SITE_URL =
  import.meta.env.VITE_MARKETING_SITE_URL || 'https://www.eedischool.com/';
export const SKIP_SUBSCRIPTION_VALIDATION =
  import.meta.env.VITE_SKIP_SUBSCRIPTION_VALIDATION === 'true' || false;

export const HOME_SCHOOL_IDS = [167333, 161922];

// The non-human AI tutor proxy that serves direct-AI (auto-moderated)
// sessions. Hardcoded per environment (TutorId/UserId: prod 461/4769126,
// dev+QA 140/3506182), overridable via VITE_AI_TUTOR_ID /
// VITE_AI_TUTOR_USER_ID.
const parseAiTutorId = (value: string | number) => {
  const id = Number(value);
  return Number.isInteger(id) && id > 0 ? id : undefined;
};
export const AI_TUTOR_USER_ID =
  parseAiTutorId(import.meta.env.VITE_AI_TUTOR_USER_ID) ??
  (env === 'prod' ? 4769126 : 3506182);
export const AI_TUTOR_ID =
  parseAiTutorId(import.meta.env.VITE_AI_TUTOR_ID) ??
  (env === 'prod' ? 461 : 140);

export const GOOGLE_AUTH_CLIENT_ID =
  '250963904963-e2uegfjodagts71r9lmv58j3ablqv6c6.apps.googleusercontent.com';

export const CLEVER_CALLBACK_URL = API_URL + '/v3/clever-login-callback';

export const CLEVER_CLIENT_ID =
  env === 'prod' ? '13eeffcb842e4660df96' : '5f4242f5e2ec9b137a53';

export const CLEVER_SSO_URL = `https://clever.com/oauth/authorize?response_type=code&redirect_uri=${CLEVER_CALLBACK_URL}&client_id=${CLEVER_CLIENT_ID}`;

/**
 * @desc - Returns the imageUrl parsed against the environment variables.
 * @return string - The parsed imageUrl.
 * @param src string - The imageUrl to be parsed.
 */
export const getImageUrl = (src: string) => {
  let imageUrl = src !== null && src !== undefined ? `${IMAGE_URL}/${src}` : '';
  if (imageUrl.length) {
    if (IMAGE_URL.length === 0 || src.indexOf('http') !== -1) {
      imageUrl = src;
    }
  }
  return imageUrl.replace(/([^:]\/)\/+/g, '$1');
};

export const getAuthToken = () => {
  return localStorage.getItem('authToken');
};

export const setAuthToken = (token: string) => {
  localStorage.setItem('authToken', token);
  Cookies.set('authToken', token, {
    path: '/',
    domain: '.eedi.com',
    secure: true,
    sameSite: 'strict'
  });
};

export const removeAuthToken = () => {
  Cookies.remove('authToken', {
    path: '/',
    domain: '.eedi.com',
    secure: true,
    sameSite: 'strict'
  });
};
